import React from "react";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Image from "next/image";

import Context from "@/context/Context";
import PageHead from "@/pages/Head";
import FooterOne from "@/components/Footer/Footer-One";
import HeaderBasic from "@/components/Header/HeaderStyle-Four";
import MobileMenu from "@/components/Header/MobileMenu";
import BackToTop from "@/pages/backToTop";
import Separator from "@/components/Common/Separator";
import BreadCrumb from "@/components/Common/BreadCrumb";
import BrandOne from "@/components/Brand/Brand-One";

import ourPartnersImg from "@/public/images/partners/our_partners.jpg";


const Partners = () => {
  return (
    <>
      <PageHead title="Nuestros Aliados - Colegio Menfis" />
      <Provider store={Store}>
        <Context>
          <HeaderBasic headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <BreadCrumb title="Nuestros Aliados" text="Nuestros Aliados" />
          <div className=" bg-color-white mt--30 flex-center">
            <div className="container col-lg-8">
              <Image
                className="w-100 rbt-radius"
                src={ourPartnersImg}
                width={407}
                height={638}
                property="true"
                alt="partners img"
              />
              <h4 className="title mt--15">
                Creemos que la fortaleza de nuestra comunidad educativa se multiplica a través de alianzas estratégicas!
              </h4>
              <p className="description mt--30 ">
                Nuestros socios, cuidadosamente seleccionados, comparten nuestro compromiso con la excelencia, la innovación y el desarrollo integral de nuestros estudiantes. Cada colaboración enriquece la experiencia educativa, proporcionando recursos adicionales y oportunidades únicas de crecimiento, tanto dentro como fuera del aula.
              </p>
              <p className="description mt--30">
                Estas alianzas aportan experiencia y apoyo directo a nuestros estudiantes, maestros y familias. Desde la integración de tecnología avanzada hasta el enriquecimiento extracurricular y el desarrollo profesional, nuestros socios contribuyen a crear un entorno de aprendizaje dinámico. Juntos, estamos comprometidos con formar personas integrales y con una mentalidad global, preparadas para los desafíos del futuro.
              </p>
              <p className="description mt--30 mb--30">
                Al asociarnos con organizaciones que comparten nuestra visión, garantizamos que Colegio Menfis se mantenga a la vanguardia de la excelencia educativa, evolucionando constantemente para satisfacer las necesidades de nuestra comunidad por eso, son parte fundamental de nuestra misión de crear un entorno escolar próspero, inclusivo y orientado hacia el futuro.
              </p>
            </div>
          </div>
          <div className="rbt-brand-area bg-color-white mb--30">
            <div className="container">
              <div className="row align-items-center g-5">
                <BrandOne />
              </div>
            </div>
          </div>
          <Separator />
          <BackToTop />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default Partners;
